import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Server, Factory, BatteryCharging, Pickaxe, Building2, Zap } from "lucide-react";
import PageHero from "../components/PageHero";
import ContactSection from "../components/ContactSection";
import { images, segments } from "../mock/mock";

const apps = [
  { icon: Factory, title: "Modular Power Generation", desc: "Rapidly deployable, utility-grade power plants scaled to your demand." },
  { icon: Zap, title: "CHP", desc: "Combined heat and power for maximum fuel efficiency and site value." },
  { icon: BatteryCharging, title: "Hybrid Microgrids", desc: "Engines paired with renewables and storage for resilient supply." },
  { icon: Building2, title: "Utilities", desc: "Grid support, peaking and baseload solutions for operators." },
  { icon: Server, title: "Data Centers", desc: "The power behind AI — reliable, always-on energy at scale." },
  { icon: Pickaxe, title: "Mining", desc: "Robust power for the most remote and demanding operations." },
];

export default function OnLand() {
  return (
    <main>
      <PageHero image={images.onLand} eyebrow="Solutions" title="On Land." subtitle={segments.onLand.body} />
      <section className="bg-white">
        <div className="max-w-[1400px] mx-auto px-5 md:px-8 py-20">
          <h2 className="oe-heading text-oe-navy text-3xl md:text-4xl mb-4">Flexible solutions for every sector</h2>
          <p className="text-muted-foreground max-w-2xl mb-12">From data centers to mining, our medium-speed engines deliver reliable, cost-efficient and future-proof power wherever it is needed.</p>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {apps.map((a) => (
              <div key={a.title} className="group border border-gray-100 rounded-xl p-8 hover:shadow-xl hover:-translate-y-1 transition-all bg-white">
                <div className="w-14 h-14 rounded-lg oe-navy flex items-center justify-center mb-6 group-hover:bg-oe-red transition-colors">
                  <a.icon size={26} className="text-white" />
                </div>
                <h3 className="text-oe-navy font-semibold text-xl mb-3">{a.title}</h3>
                <p className="text-muted-foreground text-sm leading-relaxed">{a.desc}</p>
              </div>
            ))}
          </div>
          <div className="mt-16">
            <Link to="/products" className="group inline-flex items-center gap-3 oe-navy text-white font-semibold px-8 py-4 rounded-md hover:oe-navy-2 transition-colors">
              Explore our engines <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
        </div>
      </section>
      <ContactSection />
    </main>
  );
}
